<template>
    <div class="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="{ year, value } in data" :key="year" style="display:flex">
          <h3 style="padding-bottom: 20px;" v-html="year"></h3>
          <div class="content-container">
            <div v-for="item in value" :key="item.month">
              <dl class="month-content" style="display: flex;">
                <div>
                  <dt style="float: left; width: 4em;" v-html="item.month">月</dt>
                </div>
                <div>
                  <dd style="padding-bottom: 10px; line-height: 23px;">
                    <p v-html="item.content"></p>
                  </dd>
                </div>
              </dl>
            </div>
          </div>
        </div>
      </div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
  </template>
  
  <script>
  import { ref, onMounted } from 'vue';
  import Swiper, { Navigation } from 'swiper';
  import 'swiper/swiper-bundle.min.css';
  import { getMilestoneList } from '../utils/api.js';
  
  Swiper.use([Navigation]);
  
  export default {
    name: 'SwiperDemo',
    setup() {
      const data = ref([]);
  
      onMounted(() => {
        load();
      });
  
      const load = async () => {
        try {
          const res = await getMilestoneList();
          data.value = []
          // 先将对象的条目转为数组，倒序排序，然后再推送到 data.value
            const sortedData = Object.entries(res.data).reverse();
            
            for (const [key, value] of sortedData) {
            data.value.push({
                year: key,
                value: value
            });
            }
          console.log(data.value);
          initSwiper();
        } catch (error) {
          console.error('加载数据失败:', error);
        }
      };
  
      const initSwiper = () => {
        const swiper = new Swiper('.swiper', {
          slidesPerView: 3,
          spaceBetween: 30,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          on: {
            resize: function () {
              swiper.changeDirection(getDirection());
            },
          },
        });
  
        function getDirection() {
          const windowWidth = window.innerWidth;
          return windowWidth <= 760 ? 'vertical' : 'horizontal';
        }
      };
  
      return {
        data
      };
    },
  };
  </script>
  
  <style scoped>
  html,
  body {
    position: relative;
    height: 100%;
  }
  
  body {
    background: #eee;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    color: #000;
    margin: 0;
    padding: 0;
  }
  
  /* .swiper {
    width: 50%;
    height: 100%;
  } */
  .swiper {
  position: relative;
  width: 50%; 
  margin: 0 auto; 
}

.swiper-button-next,
.swiper-button-prev {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
}

.swiper-button-next {
  right: 10px; 
}

.swiper-button-prev {
  left: 10px;
}
  
  .swiper-slide {
    font-size: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;

    width: calc((100% - 100px) / 3); 
  }
  
  @media (max-width: 760px) {
    .swiper-button-next {
      right: 20px;
      transform: rotate(90deg);
    }
  
    .swiper-button-prev {
      left: 20px;
      transform: rotate(90deg);
    }
  
    .swiper-slide {
      width: 50% !important;
      height: 100% !important;
    }
  }
  .swiper .content-container {
    /* width: 25rem; */
    text-align: justify;
    flex-grow: 1;
    overflow-y: auto;

    scrollbar-width: thin; /* 适用于Firefox */
    scrollbar-color: #888 rgba(0,0,0,0); /* 滑块颜色 轨道颜色 */
  }

  /* 自定义滚动条样式 - 适用于Webkit浏览器 (Chrome, Safari) */
  .swiper .content-container::-webkit-scrollbar {
  width: 8px; /* 滚动条宽度 */
}

.swiper .content-container::-webkit-scrollbar-thumb {
  background-color: #888; /* 滑块颜色 */
  border-radius: 10px; /* 滑块圆角 */
}

.swiper .content-container::-webkit-scrollbar-track {
  background: #eee; /* 轨道颜色 */
  border-radius: 10px; /* 轨道圆角 */
}
  </style>
  